export const moduleSlug = 'billing';
export const moduleAuth = 'Billing';

export const children = [
    {
        path: "",
        redirect: to => {
            return to.path + '/' + 'subscriptions';
        },
        meta: {},
    },
    {
        path: "subscriptions",
        component: () => import("./pages/Subscriptions.vue"),
        meta: {
            title: "Subscriptions",
            linkTitle: "Subscriptions",
            linkIcon: "refresh",
            showInNav: true,
            permission: 'Billing',
        },
    },
    {
        path: "logs",
        component: () => import("./pages/Billing.vue"),
        meta: {
            title: "Credits",
            linkTitle: "Credits",
            linkIcon: "list-ol",
            showInNav: true,
            permission: 'Billing.Credits',
        },
    },
    {
        path: "usage",
        component: () => import("./pages/Usage.vue"),
        meta: {
            title: "Credit Usage",
            linkTitle: "Credit Usage",
            linkIcon: "battery-half",
            showInNav: true,
            permission: 'Billing',
        },
    },
    {
        path: "invoices",
        component: () => import("./pages/Invoices.vue"),
        meta: {
            title: "Invoices",
            linkTitle: "Invoices",
            linkIcon: "file-text-o",
            showInNav: true,
            permission: 'Billing',
        },
    },
    {
        path: "payment-methods",
        component: () => import("./pages/PaymentMethods.vue"),
        meta: {
            title: "Payment Methods",
            linkTitle: "Payment Methods",
            linkIcon: "credit-card",
            showInNav: true,
            permission: 'Billing.PaymentMethods',
        },
    },
];